import './App.css';
import Calculator from './Components/Calculator/Calculator';
import FooterComponent from './Components/Footer/FooterComponent';

function App() {
  return (
    <div className="App">
      <Calculator/>
      <FooterComponent/>
    </div>
  );
}

export default App;
